module.exports = "../../app/cells/pages/contest/common_questions/show.erb";